const UnnamedSection = () => {
  return (
    <section
      className="w-full"
      style={{
        height: '500px',
        paddingLeft: '64px',
        paddingRight: '64px',
        backgroundImage: 'url("/Landing Page/Circle Like No Other/bottom.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}
    >
      <div className="w-full text-left">
        <p
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '16px',
            color: '#FFFFFF',
            lineHeight: '1.6',
            maxWidth: '800px'
          }}
        >
          We redefine the essence of concierge at the highest level. A single point of contact with a dedicated lifestyle manager ensures seamless access, unmatched efficiency, and transformative support for a truly elevated way of life.
        </p>
      </div>
    </section>
  )
}

export default UnnamedSection